import { useState, useEffect } from 'react';

import Card from '@material-tailwind/react/Card';
import CardHeader from '@material-tailwind/react/CardHeader';
import CardBody from '@material-tailwind/react/CardBody';
import CardFooter from '@material-tailwind/react/CardFooter';
import H5 from '@material-tailwind/react/Heading5';
import InputIcon from '@material-tailwind/react/InputIcon';
import Button from '@material-tailwind/react/Button';
import Page from 'components/login/Page';
import Container from 'components/login/Container';
import axios from 'axios';
require('dotenv').config()


export default function Login(props) {
    useEffect(() => {
        return () => {
            axios.get(process.env.REACT_APP_API + "/")
        }
    }, []);
    const onSubmit = (e) => {
        e.preventDefault();
        // axios.get(process.env.REACT_APP_API + "/users",)
        // .then(res => {
        //     console.log(res.data)
        // })
        // .catch(error => {
        //     console.log(error)
        // }) 
        axios.post(process.env.REACT_APP_API + "/users/auth", {
            name: userName,
            daysFree: []
        })
        .then(res => {
            localStorage.setItem("user", JSON.stringify(res.data))
            return props.history.push("/dashboard")
        })
        .catch(err => {
            console.log(err);
        })
    }
    const [userName, setUsername ] = useState("");
    return (
        <Page>
            <Container>
                <Card>
                    <CardHeader color="lightBlue">
                        <H5 color="white" style={{ marginBottom: 0 }}>
                            Login
                        </H5>
                    </CardHeader>

                    <CardBody>
                        <form>
                        <div className="mb-12 px-4 bg-bb">
                            <div className="mt-2">
                                <InputIcon
                                onChange={(e) => setUsername(e.target.value)}
                                    type="text"
                                    required
                                    color="lightBlue"
                                    placeholder="Name"
                                    iconName="person"
                                />
                            </div>
                        </div>
                        </form>
                    
                    </CardBody>
                    <CardFooter>
                        <div className="flex justify-center bg-bb">
                            <Button
                                color="lightBlue"
                                onClick={onSubmit}
                                buttonType="link"
                                size="lg"
                                ripple="dark"
                            >
                                Get Started
                            </Button>
                        </div>
                    </CardFooter>
                </Card>
            </Container>
        </Page>
    );
}
